@if (isLoading()) {
<app-loader message="Chargement des données..." class="margin"></app-loader>
} @else if (enseignant()) {

<div class="conteneur">
  <!-- Planning des cours -->
  <mat-card appearance="raised" class="planning-card">
    <mat-card-header class="card-header">
      <mat-card-title class="fx-direction-row fx-align-item-center fx-gap-10">
        <span class="header-name">
          <app-icon icon="planning-enseignant" type="do" class="header-icon"></app-icon>
          <span>Mon planning des cours</span>
        </span>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content class="card-content" style="padding-top: 16px;">
      @if (planningConfig()) {
      <app-enseignant-planning [idEnseignant]="idEnseignant" [config]="planningConfig()!" [coursList]="coursList()"
        [preview]="false" [mode]="'detail'">
      </app-enseignant-planning>
      }
    </mat-card-content>
  </mat-card>

  <mat-card appearance="raised" class="profile-card">

    <!-- Header identité -->
    <mat-card-header class="card-header">
      <mat-card-title class="fx-direction-row fx-align-item-center fx-gap-10">
        <span class="header-name">
          <app-icon icon="niveau-musical" type="do" class="header-icon"></app-icon>
          <span>Mes départements / disciplines / niveaux enseignés</span>
        </span>
      </mat-card-title>
    </mat-card-header>

    <!-- Sections departements/disciplines/niveaux -->
    <mat-card-content class="card-content">
      <div class="profile-sections">
        <div class="profile-section">
          <app-department-tree [nodes]="enseignant()!.departmentsNode ?? []" />
        </div>
      </div>
    </mat-card-content>

  </mat-card>

</div>

}
